import { gql } from '@apollo/client';

import { TicketStatus } from '@work4all/models/lib/Enums/TicketStatus.enum';

type Props = {
  ids: number[];
  followUpDate: string;
};

export const getKindFiltersCountsQuery = ({ ids, followUpDate }: Props) => {
  if (ids.length === 0) {
    return null;
  }

  const requests: string[] = [];

  ids.forEach((id) => {
    const filter = getRequestFilter({ id, followUpDate });

    requests.push(`request_${id}: getTickets(filter: ${filter}) {
      total
    }`);
  });

  const joinedRequests = requests.join('\n');

  return gql`query GetKindFiltersCounts { ${joinedRequests} }`;
};

type GetRequestFilterProps = {
  id: number;
  followUpDate: string;
};

const STATUS_LIST = [TicketStatus.OFFEN];

const getRequestFilter = ({ id, followUpDate }: GetRequestFilterProps) => {
  const filters = [
    {
      wiedervorlage: {
        $lt: followUpDate,
      },
    },
    {
      ticketArtCode: {
        $eq: id,
      },
    },
    {
      $and: [
        {
          status1: {
            $in: STATUS_LIST,
          },
        },
      ],
    },
  ];

  const stringifiedFilters = JSON.stringify(filters).replace(/"/g, '\\"');

  return `"${stringifiedFilters}"`;
};
